<template>
  <v-footer id="core-footer">
    <div class="footer-items">
      <!-- <span v-for="link in links" :key="link.name">
        <a :href="link.Link" class="tertiary--text footer-links">{{ link.name }}</a>
      </span> -->
    </div>
    <v-spacer />
    <span class="font-weight-light copyright">
      &copy;
      {{ new Date().getFullYear() }}
      {{ $t('Common.title') }} system by
      <a href="https://www.assistedcoding.eu" target="_blank">assistedcoding.eu</a>
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [{ name: "Dashboard", Link: "/#" }]
  })
};
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
